module.exports = __webpack_public_path__ + "img/tutorial-02.e516c657.jpg";